(function($) {

    var methods = {
        init: function(options) {
            var opts = $.extend({}, $.fn.sharePop.defaults, options);

            return this.each(function() {
                let $dlg = $(this);
                const shareSuccess = function (/*msg*/) {
                        _setupAck($dlg);
                        window.setTimeout(function () {
                            $dlg.modal('hide');
                        }, 4000);
                    },
                    shareFail = function (j, s, e) {
                        $dlg.find('.error').text(e);
                        _setupFail($dlg);
                    },
                    enableSubmit = function () {
                        $submit.removeClass('disabled').off().on('click', function (e) { e.preventDefault(); $dlg.find('form').submit(); });
                    },
                    disableSubmit = function () {
                        $submit.off('click').on('click', function (e) { e.preventDefault(); }).addClass('disabled');
                    },
                    onShow = function (/* e */) {
                        let $this = $(this);
                        _setupMain($this);
                        // clear form elements (except "from")
                        $this.find('#t').val('');
                        $this.find('#msg').val('');
                        setTimeout(function () { enableSubmit(); }, 2000);
                    };

                // open-listener
                $dlg.on('show.bs.modal', onShow);
                // submit button
                var $submit = $dlg.find('#share_submit');
                $submit.click(function (e) { e.preventDefault(); $(this).closest('form').submit(); });
                disableSubmit();

                // install <form> tag dynamically. Otherwise we get into big problems with ASP.NET.
                $dlg.find('.form').each(function () {
                    var $this = $(this);
                    var $form = $('<form id="' + opts.formID + '" action="" method="post"></form>');
                    $this.children().detach().appendTo($form);
                    $this.append($form);
                });

                // validation
                var $form = $('#' + opts.formID);
                var $formKill = false;

                $form.validate({ onkeyup: false });
                $.validator.messages.required = opts.requiredMessage + '.';
                $form.submit(function (e) {
                    e.preventDefault();

                    // debounce submit.
                    if ($formKill)
                        return false;
                    $formKill = true;
                    setTimeout(function () { $formKill = false; }, 500);

                    if ($form.valid()) {
                        disableSubmit();
                        _shareSession($form.find('#f').val(), $form.find('#t').val(), $form.find('#msg').val(), shareSuccess, shareFail);
                    }
                });
            });
        },
        // open 
        open: function() {
            this.modal('show');
            return this;
        },
        close: function() {
            this.modal('hide');
            return this;
        },
        cancel: function() {
            this.modal('hide');  // just close the dialog.
            return this;
        }
    };

    // plugin method dispatcher.
    $.fn.sharePop = function(method) {
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            console.error('Method ' + method + ' does not exist on jQuery.sharePop');
        }
    };

    $.fn.sharePop.defaults = { dialogClass: 'overlay', wrapClass: 'sharePopDlg', formID: '_f8_share_pop', width: 360, requiredMessage: 'Please enter a value', emailMessage: 'Valid email address required' };

    function _setupMain(dlg) {
        _setupSections(dlg, true, false, false);
    }

    function _setupAck(dlg) {
        _setupSections(dlg, false, true, false);
    }

    function _setupFail(dlg) {
        _setupSections(dlg, false, false, true);
    }

    function _setupSections(dlg, m, a, f)
    {
        console.log('_setupSections: ' + dlg.find('.main').length + '; ' + dlg.closest('.modal').find('.main').length);
        dlg.find('.main').toggle(m);
        dlg.find('.ack').toggle(a);
        dlg.find('.fail').toggle(f);
    }

    function _shareSession(strFrom, strTo, strComment, fsuccess, ffail) {
        var strUrl = window.location.toString().replace(/([^\?]*)\?(.*)/, '$1/ShareSession?$2');
        var $data = '{ "strFrom" : "' + strFrom + '", "strTo" : "' + strTo + '", "strComment" : "' + strComment + '" }';
        $.ajax({ cache: false, type: 'POST', url: strUrl, data: $data, contentType: 'application/json; charset=utf-8', dataType: 'json', success: fsuccess, error: ffail });
    }
})(jQuery);
